import type { SpaceshipDefinition } from "./spaceshipData.js";
import { worldForChapter } from "./worldData.js";

export function canUnlockSpaceship(def: SpaceshipDefinition, bestChapter: number): boolean {
  if (def.unlockCondition.type === "default") return true;
  if (def.unlockCondition.type === "chapter") return bestChapter >= def.unlockCondition.value;
  if (def.unlockCondition.type === "world") {
    return worldForChapter(bestChapter).worldNo >= def.unlockCondition.value;
  }
  return false;
}
